import type { FC } from 'react'
import styled from 'styled-components'

import SmallPill from '@/components/SmallPill'
import type { AdverseCredit } from '@/types/adverseCredit'

import AdverseCreditFields from './AdverseCreditFields'

const Container = styled.div`
  display: grid;
  gap: 10px;
`

const AdverseCreditContainer = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
`

export type Fields = AdverseCredit[]

interface Props {
  values: Fields
  onChangeValues: (fields: Fields) => void
  onAdd: () => void
  disableEditing?: boolean
}

const AdverseCreditsFields: FC<Props> = ({
  values,
  onChangeValues,
  onAdd,
  disableEditing,
}) => (
  <Container>
    <div>
      {values.length === 0 ? (
        <p>No adverse credit.</p>
      ) : (
        values.map((adverseCredit, i) => (
          <AdverseCreditContainer key={i}>
            <AdverseCreditFields
              key={i}
              values={adverseCredit}
              onChangeValues={newAdverseCreditFields =>
                onChangeValues(
                  values.map((a, k) => (k === i ? newAdverseCreditFields : a)),
                )
              }
              onRemove={() => onChangeValues(values.filter((_, k) => i !== k))}
              disableEditing={disableEditing}
            />
          </AdverseCreditContainer>
        ))
      )}
    </div>
    {!disableEditing && <SmallPill onClick={onAdd}>Add another</SmallPill>}
  </Container>
)

export default AdverseCreditsFields
